import {
  Box,
  Button,
  CircularProgress,
  Fade,
  Grid,
  TextField,
  Typography,
  Tooltip,
} from "@mui/material";
import moment from "moment-jalaali";
import { useEffect, useState } from "react";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePicker from "react-multi-date-picker";
import DateObject from "react-date-object";
import InputIcon from "react-multi-date-picker/components/input_icon";
import Toolbar from "react-multi-date-picker/plugins/toolbar";
import { convertDigitToEnglish } from "common/method/convertDigitToEnglish";
import { useDispatch, useSelector } from "react-redux";
import { insert_offline_order } from "redux/offlineorder/insert_offline_order";
import { actionTypes as select_instrumentActionTypes } from "redux/select_instrument";
import { actionTypes as actionTypesNotif } from "redux/notificationAlert";
import { handleNotificationAlertTryUpdate } from "common/method/handleNotificationAlert";
import { actionTypes as selectLivePortfolioAction } from "redux/charts-tables-data/select_live_portfolio";
import { useHistory } from "react-router-dom";
import { actionTypes } from "redux/offlineorder/select_offline_orders";
import { numberWithCommas } from "common/method/seprateNumberFromComma";
import OutOfStockModal from "./OutOfStockModal";
import StockPrice from "pages/offlineOrders/stockPriceTable";
import { makeStyles } from "@mui/styles";

const SYMBOLS = [
  { name: "برلیان(صندوق سرمایه گذاری برلیان-سهام)", isin: "IRT1BERL0001" },
  { name: "بلد(صندوق درآمد ثابت برليان شهر-سهام)", isin: "IRT3BLDF0001" },
];

const resetOrderFieldsOnPriceTypeChange = (prev, priceType) => ({
  ...prev,
  priceType,
  date: prev.date ?? new DateObject({ calendar: persian }).add(7, "days"),
  quantity: "",
  price: "",
});

const useStyles = makeStyles(() => ({
  tooltip: {
    maxWidth: 250,
    fontSize: 12,
    padding: 5,
  },
}));

const InsertOrders = () => {
  const [loading, setLoading] = useState(false);
  const [openWarningModal, setOpenWarningModal] = useState(false);
  const [commission, setCommission] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const [currentOrder, setCurrentOrder] = useState({
    symbol: null,
    side: "",
    price: "",
    priceType: "",
    quantity: "",
    totalValue: "",
    date: new DateObject({ calendar: persian, locale: persian_fa }).add(
      7,
      "days",
    ),
  });

  const [showPriceHint, setShowPriceHint] = useState(false);
  const classes = useStyles();

  const bestLimitsReducer = useSelector(
    (state) => state.select_best_limits_Reducer,
  );

  const prices = Object.values(bestLimitsReducer?.data || []);

  const minAndMaxPrice = Object.values(prices).flatMap((item) => [
    item.request_price,
    item.offer_price,
  ]);

  const filtered = minAndMaxPrice.filter((price) => price > 0);

  const min_price = Math.min(...filtered);
  const max_price = Math.max(...filtered);

  const isSymbolSelected = !!currentOrder.symbol;
  const isSideSelected = !!currentOrder.side;
  const isPriceTypeSelected = !!currentOrder.priceType;
  const isFormVisible =
    isSymbolSelected && isSideSelected && isPriceTypeSelected;

  useEffect(() => {
    currentOrder.side === "SELL"
      ? setCommission(0.002375)
      : setCommission(0.00232);
  }, [currentOrder.side]);

  function removeCommas(value) {
    if (!value) return "";
    return value.toString().replace(/,/g, "");
  }

  const recalcOrder = (prev, changedField, value) => {
    let quantity =
      changedField === "quantity" ? Number(value) : Number(prev.quantity);
    let price = changedField === "price" ? Number(value) : Number(prev.price);
    let totalValue =
      changedField === "totalValue" ? Number(value) : Number(prev.totalValue);

    let newQuantity = quantity;
    let newPrice = price;
    let newTotal = totalValue;

    if (changedField === "price" && totalValue && price > 0) {
      newQuantity = Math.floor(totalValue / (price * (1 + commission)));
    }

    if (changedField === "quantity" && price > 0 && quantity > 0) {
      newTotal = Math.floor(price * quantity * (1 + commission));
    }

    if (changedField === "totalValue" && price > 0 && totalValue > 0) {
      newQuantity = Math.floor(totalValue / (price * (1 + commission)));
    }

    return {
      ...prev,
      quantity: newQuantity || "",
      price: newPrice || "",
      totalValue: newTotal || "",
    };
  };

  useEffect(() => {
    if (currentOrder.priceType === "FIXED" && bestLimitsReducer?.data) {
      setCurrentOrder((prev) => ({
        ...prev,
        price: bestLimitsReducer?.data[1]?.request_price || "",
      }));
    }
  }, [bestLimitsReducer.data]);

  useEffect(() => {
    dispatch({
      type: select_instrumentActionTypes?.selectInstrumentAsync,
    });
    dispatch({ type: selectLivePortfolioAction.selectLivePortfolioAsync });
  }, [dispatch]);

  const reducerLivePortfolio = useSelector(
    (state) => state.select_live_portfolio_reducer,
  );
  const handleAddOrder = () => {
    if (!isFormVisible || !currentOrder.date) {
      dispatch({
        type: actionTypesNotif.warning,
        textAlert: "لطفاً تاریخ اعتبار را وارد نمایید.",
      });
      return;
    }

    if (!currentOrder.priceType) {
      dispatch({
        type: actionTypesNotif.warning,
        textAlert: "لطفاً نوع قیمت را انتخاب نمایید.",
      });
      return;
    }

    if (currentOrder.priceType === "CUSTOM" && !currentOrder.price) {
      dispatch({
        type: actionTypesNotif.warning,
        textAlert: "لطفاً قیمت دلخواه را وارد نمایید.",
      });
      return;
    }

    if (!currentOrder.quantity) {
      dispatch({
        type: actionTypesNotif.warning,
        textAlert: "لطفاً تعداد را وارد نمایید.",
      });
      return;
    }

    if (
      currentOrder.price * currentOrder.quantity * (1 + commission) <
      5000000
    ) {
      dispatch({
        type: actionTypesNotif.warning,
        textAlert: "حداقل ارزش معامله می بایست بیشتر از 5 میلیون ریال باشد.",
      });
      return;
    }

    if (
      currentOrder.quantity * currentOrder.price >
        reducerLivePortfolio?.data?.remain &&
      currentOrder.side === "BUY"
    ) {
      dispatch({
        type: actionTypesNotif.warning,
        textAlert:
          "سفارش شما بیشتر از قدرت خریدتان است. لطفاً تعداد یا قیمت را کاهش دهید یا موجودی حساب خود را افزایش دهید.",
      });
      return;
    }

    const dateObject =
      currentOrder.date instanceof DateObject
        ? currentOrder.date
        : new DateObject(currentOrder.date);
    const persianDateStr = dateObject.format("jYYYY/jMM/jDD");

    const englishDateStr = convertDigitToEnglish(persianDateStr);

    const formattedDate = moment(englishDateStr, "jYYYY/jMM/jDD").format(
      "YYYY/MM/DD",
    );
    const isBuy = currentOrder.side === "BUY";
    const isSell = currentOrder.side === "SELL";

    const data = {
      side: currentOrder.side,
      trigger_datetime: `${formattedDate} 00:00:00.000000`,
      symbol_isin: currentOrder.symbol.isin,

      price: Number(currentOrder.price),
      quantity: Number(currentOrder.quantity),

      order_value: isSell ? null : Number(currentOrder.totalValue),
    };

    setLoading(true);

    insert_offline_order(data)
      .then((res) => {
        handleNotificationAlertTryUpdate(res);
        dispatch({
          type: actionTypes.selectOfflineOrdersAsync,
          payload: { data: { state: -1 } },
        });
      })
      .finally(() => setLoading(false));
  };

  const SelectCard = ({ active, onClick, children, colorVariant }) => {
    const getActiveStyles = () => {
      if (!active) {
        return {
          border: "1px solid #ddd",
          backgroundColor: "#fff",
        };
      }

      if (colorVariant === "buy") {
        return {
          border: "2px solid #2e7d32",
          backgroundColor: "#e8f5e9",
        };
      }

      if (colorVariant === "sell") {
        return {
          border: "2px solid #d32f2f",
          backgroundColor: "#ffebee",
        };
      }

      return {
        border: "2px solid #1976d2",
        backgroundColor: "#e3f2fd",
      };
    };

    const activeStyles = getActiveStyles();

    return (
      <Box
        onClick={onClick}
        sx={{
          flex: 1,
          p: 1,
          borderRadius: 2,
          flexDirection: "row",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 1,
          textAlign: "center",
          cursor: "pointer",
          transition: "all 0.3s ease",
          fontSize: { md: "13px", xs: "12px" },
          ...activeStyles,
          "&:hover": {
            backgroundColor: active ? activeStyles.backgroundColor : "#f5f5f5",
          },
        }}
      >
        {children}
      </Box>
    );
  };

  return (
    <Box
      sx={{
        mx: "auto",
        py: 2,
        px: { md: 4, xs: 2 },
        borderRadius: 3,
        boxShadow: 3,
        bgcolor: "background.paper",
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#17c191",
        display: "flex",
        flexDirection: "column",
        minHeight: 570,
      }}
    >
      <Typography variant="h6" textAlign="center" mb={1}>
        ثبت سفارش جدید
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: 2,
          backgroundColor: "#f8f9fa",
          borderRadius: 3,
          px: 2,
          py: 1,
          border: "1px solid #e0e0e0",
          width: "100%",
          mb: 1,
        }}
      >
        <Box
          sx={{
            flex: "1 1 100px",
            textAlign: "center",
          }}
        >
          <Typography fontSize={10} color="text.secondary">
            قدرت خرید (ریال)
          </Typography>
          <Typography fontSize={12} fontWeight="bold" color="success.main">
            {Number(reducerLivePortfolio?.data?.remain || 0).toLocaleString()}
          </Typography>
        </Box>

        <Box
          sx={{
            flex: "1 1 100px",
            textAlign: "center",
          }}
        >
          <Typography fontSize={10} color="text.secondary">
            خالص دارایی (ریال)
          </Typography>
          <Typography fontSize={12} fontWeight="bold" color="primary.main">
            {Number(
              reducerLivePortfolio?.data?.net_Worth || 0,
            ).toLocaleString()}
          </Typography>
        </Box>
        <Box
          sx={{
            flex: {
              xs: "1 1 100%",
              sm: "1 1 auto",
            },
            display: "flex",
            justifyContent: {
              xs: "stretch",
              sm: "flex-end",
            },
          }}
        >
          <Button
            variant="contained"
            size="small"
            sx={{
              borderRadius: 2,
              px: 3,
              fontSize: 12,
              width: "100%",
            }}
            onClick={() => {
              history.push("/deposit");
            }}
          >
            افزایش موجودی
          </Button>
        </Box>
      </Box>

      <Typography mb={1}>انتخاب نماد</Typography>
      <Grid container spacing={2} mb={3}>
        {SYMBOLS.map((item) => (
          <Grid item xs={6} key={item.isin}>
            <SelectCard
              active={currentOrder.symbol?.isin === item.isin}
              onClick={() =>
                setCurrentOrder({
                  ...currentOrder,
                  symbol: item,
                  side: "",
                })
              }
            >
              {item.name}
            </SelectCard>
          </Grid>
        ))}
      </Grid>

      <Fade in={isSymbolSelected}>
        <Box
          sx={{
            opacity: isSymbolSelected ? 1 : 0.4,
            pointerEvents: isSymbolSelected ? "auto" : "none",
            mb: 3,
          }}
        >
          {isSymbolSelected && (
            <Grid container spacing={2} mb={3}>
              <Grid item xs={12}>
                <StockPrice symbol={currentOrder.symbol} />
              </Grid>
            </Grid>
          )}
          <Typography mb={1}>نوع سفارش</Typography>
          <Grid container spacing={2}>
            {["BUY", "SELL"].map((side) => (
              <Grid item xs={6} key={side}>
                <SelectCard
                  active={currentOrder.side === side}
                  colorVariant={side === "BUY" ? "buy" : "sell"}
                  onClick={() => {
                    setCurrentOrder((prev) => ({
                      ...prev,
                      side,
                      priceType: "",
                      price: "",
                    }));
                  }}
                >
                  {side === "BUY" ? "خرید" : "فروش"}
                </SelectCard>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Fade>

      <Fade in={isSideSelected}>
        <Box
          sx={{
            opacity: isSideSelected ? 1 : 0.4,
            pointerEvents: isSideSelected ? "auto" : "none",
            mb: 3,
          }}
        >
          <Typography mb={1}>نوع قیمت</Typography>

          <Grid container spacing={2}>
            {[
              { value: "FIXED", label: "قیمت بازار", tooltip: "قیمت بازار" },
              { value: "CUSTOM", label: "قیمت دلخواه", tooltip: "قیمت دلخواه" },
            ].map((item) => (
              <Grid item xs={6} key={item.value}>
                <Box>
                  <SelectCard
                    active={currentOrder.priceType === item.value}
                    onClick={() =>
                      setCurrentOrder((prev) => {
                        if (prev.priceType === item.value) return prev;
                        return resetOrderFieldsOnPriceTypeChange(
                          prev,
                          item.value,
                        );
                      })
                    }
                  >
                    {item.label}
                    <Tooltip
                      style={{ width: "16px" }}
                      className="mb-[2px]"
                      title={<p className="p-2 m-0">{item.tooltip}</p>}
                      placement={"bottom"}
                      arrow
                      classes={{ tooltip: classes.tooltip }}
                      enterTouchDelay={1}
                    >
                      <img src="/media/image/Group 12485.png" alt="" />
                    </Tooltip>
                  </SelectCard>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Fade>

      <Fade in={isFormVisible}>
        <Box
          sx={{
            opacity: isFormVisible ? 1 : 0.4,
            pointerEvents: isFormVisible ? "auto" : "none",
            mb: 3,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 2,
            }}
          >
            <Typography>جزئیات سفارش</Typography>
          </Box>

          <Grid container spacing={2}>
            {currentOrder.priceType === "CUSTOM" && (
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  size="small"
                  label={
                    currentOrder.side === "SELL" ? "حداقل قیمت" : "حداکثر قیمت"
                  }
                  value={numberWithCommas(currentOrder.price)}
                  onFocus={() => setShowPriceHint(true)}
                  onBlur={() => setShowPriceHint(false)}
                  helperText={
                    showPriceHint &&
                    min_price &&
                    max_price && (
                      <Box
                        sx={{ display: "flex", gap: 1, alignItems: "center" }}
                      >
                        <Typography variant="caption">
                          بازه قیمت بازار:
                        </Typography>

                        <Typography
                          variant="caption"
                          sx={{
                            color: "success.main",
                            cursor: "pointer",
                            fontWeight: 600,
                          }}
                          onMouseDown={() =>
                            setCurrentOrder((prev) =>
                              recalcOrder(prev, "price", Number(min_price)),
                            )
                          }
                        >
                          {numberWithCommas(min_price)}
                        </Typography>

                        <Typography variant="caption">-</Typography>

                        <Typography
                          variant="caption"
                          sx={{
                            color: "error.main",
                            cursor: "pointer",
                            fontWeight: 600,
                          }}
                          onMouseDown={() =>
                            setCurrentOrder((prev) =>
                              recalcOrder(prev, "price", Number(max_price)),
                            )
                          }
                        >
                          {numberWithCommas(max_price)}
                        </Typography>
                      </Box>
                    )
                  }
                  onChange={(e) => {
                    const rawValue = removeCommas(e.target.value);
                    if (!/^\d*$/.test(rawValue)) return;

                    setCurrentOrder((prev) =>
                      recalcOrder(prev, "price", Number(rawValue)),
                    );
                  }}
                />
              </Grid>
            )}

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                size="small"
                label={"کل مبلغ (ریال)"}
                value={numberWithCommas(currentOrder.totalValue)}
                onChange={(e) => {
                  const rawValue = removeCommas(e.target.value);
                  if (!/^\d*$/.test(rawValue)) return;

                  setCurrentOrder((prev) =>
                    recalcOrder(prev, "totalValue", Number(rawValue)),
                  );
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                size="small"
                label="تعداد"
                value={numberWithCommas(currentOrder.quantity)}
                onChange={(e) => {
                  const rawValue = removeCommas(e.target.value);
                  if (!/^\d*$/.test(rawValue)) return;

                  setCurrentOrder((prev) =>
                    recalcOrder(prev, "quantity", Number(rawValue)),
                  );
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ display: "flex", alignItems: "center", gap: "1px" }}>
                <Typography fontSize={14} sx={{ minWidth: "85px" }}>
                  تاریخ اعتبار:
                </Typography>
                <DatePicker
                  style={{ height: 40 }}
                  containerStyle={{ width: "100%" }}
                  value={currentOrder.date}
                  onChange={(date) =>
                    setCurrentOrder({ ...currentOrder, date })
                  }
                  calendar={persian}
                  locale={persian_fa}
                  format="YYYY/MM/DD"
                  render={<InputIcon style={{ width: "100%", height: 40 }} />}
                  plugins={[<Toolbar position="bottom" />]}
                />
              </Box>
            </Grid>
            <Grid item xs={12}>
              {currentOrder.totalValue && currentOrder.price && (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    justifyContent: "space-between",
                    gap: { xs: 0.5, sm: 3 },
                    pt: 1,
                    fontSize: 12,
                    borderTop: "1px solid",
                    borderColor: "divider",
                  }}
                >
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <Typography fontSize={"11px"} color="text.secondary">
                      کارمزد :
                    </Typography>
                    <Typography fontSize={"11px"}>
                      {numberWithCommas(
                        Number(currentOrder.totalValue * commission).toFixed(0),
                      )}{" "}
                      ریال
                    </Typography>
                  </Box>

                  <Box sx={{ display: "flex", gap: 1 }}>
                    <Typography fontSize={"11px"} color="text.secondary">
                      ارزش معامله :
                    </Typography>
                    <Typography fontSize={"11px"} fontWeight={500}>
                      {numberWithCommas(
                        Number(
                          currentOrder.price *
                            currentOrder.quantity *
                            (1 + commission),
                        ).toFixed(0),
                      )}{" "}
                      ریال
                    </Typography>
                  </Box>
                </Box>
              )}
            </Grid>
          </Grid>
        </Box>
      </Fade>

      <Button
        fullWidth
        variant="contained"
        disabled={!isFormVisible || loading}
        onClick={handleAddOrder}
        sx={{ mt: "auto" }}
        color={currentOrder.side === "SELL" ? "error" : "primary"}
      >
        {currentOrder.side === "SELL" ? "ثبت سفارش فروش" : "ثبت سفارش خرید"}
        {loading && <CircularProgress size={16} sx={{ ml: 1 }} />}
      </Button>
      <OutOfStockModal
        openWarningModal={openWarningModal}
        setOpenWarningModal={setOpenWarningModal}
      />
    </Box>
  );
};

export default InsertOrders;
